module.exports = __webpack_public_path__ + "img/TequilaTearsCover_lowres.03a58ae8.jpeg";